// Order for recertification categories shown in groups (cycles and templates). A group sits where
// its earliest category does, and every reorder renumbers the whole list group by group, so each
// group's categories stay together and `sequence` alone records both the group order and the order
// within each group.

/** Group names in display order: by each group's earliest category. */
export let groupsInOrder = <T>(
  items: T[],
  groupOf: (item: T) => string,
  sequenceOf: (item: T) => number,
): string[] => [
  ...new Set(
    items.toSorted((a, b) => sequenceOf(a) - sequenceOf(b)).map(groupOf),
  ),
]

/** Every group's items in turn, in `groups` order; the list a reorder saves. */
export let itemsInGroupOrder = <T>(
  items: T[],
  groups: string[],
  groupOf: (item: T) => string,
): T[] => groups.flatMap((g) => items.filter((item) => groupOf(item) === g))

export let moveItem = <T>(list: T[], from: number, to: number): T[] =>
  list.filter((_, i) => i !== from).toSpliced(to, 0, list[from])
